import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessmentCriteria } from 'src/screens/shared/application/assessment/details/assessment-criteria/ProjectApplicationAssessmentCriteria'

export const PfKapAssessmentCriteriaPage = (): ReactElement => {
  const { projectId, assessmentId } = useParams()
  const pf_kap_project_id = parseInt(projectId as string)
  const pf_kap_assessment_id = parseInt(assessmentId as string)

  return (
    <ProjectApplicationAssessmentCriteria
      baseUrl="/pf-kap"
      projectId={pf_kap_project_id}
      assessmentId={pf_kap_assessment_id}
    />
  )
}
